import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';

//Import Data
import MainNav from '../../../mock-data/MainNav.json';

function MainMenu( props ) {
  const { categories } = props;
  const [ path, setPath ] = useState( "" );

  useEffect( () => {
    setPath( window.location.pathname );
  } )

  useEffect( () => {
    let mainNav = document.querySelector( ".header .main-nav .menu" );
    if ( mainNav.querySelector( ".active" ) )
      mainNav.querySelector( ".active" ).classList.remove( "active" );

    if ( props.active >= 0 )
      mainNav.childNodes[ props.active ].classList.add( "active" );
  }, [] )

  const buduj = categories[0];
  const instaluj = categories[1];
  const wykanczaj = categories[2];
  const urzadzaj = categories[4];
  const narzedzia = categories[7];

  const categoryUrl = (item) => item && item.category_slug
    ? `${process.env.PUBLIC_URL}/produkty/${item.category_slug}/`
    : `${process.env.PUBLIC_URL}/produkty`;

  return (
    <nav className="main-nav">
      <ul className="menu sf-arrows">
        <li className={ path.indexOf( "produkty" ) > -1 ? 'active' : '' }>
          <Link to={categoryUrl()} className="sf-with-ul">Produkty</Link>
          <div className="megamenu">
            <div className="row">
              {
                buduj && buduj.category_active === 1 ?
                  <div className="col-lg-4">
                    <div className="menu-title">
                      <Link to={categoryUrl(buduj)}>{ buduj.category_name }</Link>
                    </div>
                    <ul>
                    {
                      buduj.all_children.map(child => (
                        child.category_active === 1 ?
                          <li key={child.category_id}>
                            <Link className="sub-category" to={categoryUrl(child)}>{ child.category_name }</Link>
                          </li>
                        : null
                      ))
                    }
                    </ul>
                  </div>
                : null
              }
              <div className="col-lg-4">
                {
                  instaluj && instaluj.category_active === 1 ? 
                    <>
                      <div className="menu-title">
                        <Link to={categoryUrl(instaluj)}>{ instaluj.category_name }</Link>
                      </div>
                      <ul>
                      {
                        instaluj.all_children.map(child => (
                          child.category_active === 1 ?
                            <li key={child.category_id}>
                              <Link className="sub-category" to={categoryUrl(child)}>{ child.category_name }</Link>
                            </li>
                          : null
                        ))
                      }
                      </ul>
                    </>
                  : null
                }
                {
                  wykanczaj && wykanczaj.category_active === 1 ? 
                    <>
                      <div className="menu-title">
                        <Link to={categoryUrl(wykanczaj)}>{ wykanczaj.category_name }</Link>
                      </div>
                      <ul>
                      {
                        wykanczaj.all_children.map(child => (
                          child.category_active === 1 ?
                            <li key={child.category_id}>
                              <Link className="sub-category" to={categoryUrl(child)}>{ child.category_name }</Link>
                            </li>
                          : null
                        ))
                      }
                      </ul>
                    </>
                  : null
                }
              </div>
              <div className="col-lg-4">
                {
                  urzadzaj && urzadzaj.category_active === 1 ?
                    <>
                      <div className="menu-title">
                        <Link to={categoryUrl(urzadzaj)}>{ urzadzaj.category_name }</Link>
                      </div>
                      <ul>
                      {
                        urzadzaj.all_children.map(child => (
                          child.category_active === 1 ?
                            <li key={child.category_id}>
                              <Link className="sub-category" to={categoryUrl(child)}>{ child.category_name }</Link>
                            </li>
                          : null
                        ))
                      }
                      </ul>
                    </>
                  : null
                }
                {
                  narzedzia && narzedzia.category_active === 1 ?
                    <>
                      <div className="menu-title">
                        <Link to={categoryUrl(narzedzia)}>{ narzedzia.category_name }</Link>
                      </div>
                      <ul>
                      {
                        narzedzia.all_children.map(child => (
                          child.category_active === 1 ?
                            <li key={child.category_id}>
                              <Link className="sub-category" to={categoryUrl(child)}>{ child.category_name }</Link>
                            </li>
                          : null
                        ))
                      }
                      </ul>
                    </>
                  : null
                }
              </div>
            </div>
          </div>
        </li>
        {
          MainNav.menu.map( ( menu, index ) => (
            <li className={ menu.class + `${ path.indexOf( `${menu.url}` ) > -1 ? 'active' : '' }` } key={ "Menu" + index }>
              <Link to={ `${ process.env.PUBLIC_URL }/${menu.url}` } className={menu.classWishlist} title={menu.title}>{ menu.name }</Link>
            </li>
          ) )
        }
      </ul>
    </nav>
  );
}

const mapStateToProps = ( state ) => {
  return {
    categories: state.categories.categories ? state.categories.categories : []
  }
}

export default connect(mapStateToProps)(MainMenu);
